import React, { lazy, Suspense, useState, useEffect  } from 'react';
import Fade from '../components/shared/Fade';

import Seo from '../components/shared/Seo';

const Banner = lazy(() => import('../components/Home/Banner/Banner'));
const BannerMob = lazy(() => import('../components/Home/Banner/BannerMob'));
const Mission = lazy(() => import('../components/Home/Mission'));
const Video = lazy(() => import('../components/Home/Video'));
const OurValues = lazy(() => import('../components/Home/OurValues'));
const CompanyHighlights = lazy(() => import('../components/Home/CompanyHighlights'));
const GlobalPresence = lazy(() => import('../components/Home/GlobalPresence'));
const WhyChoose = lazy(() => import('../components/Home/WhyChoose'));
const WhatOffer = lazy(() => import('../components/Home/WhatOffer'));
const StayUpdated = lazy(() => import('../components/Home/StayUpdated'));
const FeedBack = lazy(() => import('../components/Home/FeedBack'));

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(min-width: 640px)').matches;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 640px)');
    const handleChange = (event) => setIsDesktop(event.matches);

    setIsDesktop(mediaQuery.matches);
    mediaQuery.addEventListener?.('change', handleChange);

    return () => {
      mediaQuery.removeEventListener?.('change', handleChange);
    };
  }, []);

  return isDesktop;
};

function Home({ currentLang }) {
  const isDesktop = useIsDesktop();

  return (
    <div className='relative overflow-hidden'>
      <h1 data-seo-h1 style={{position:'absolute',left:'-10000px',top:'auto',width:'1px',height:'1px',overflow:'hidden'}}>Avad Gate Global Business Solutions</h1>{/*seo-h1*/}
      <Seo title="Avad Gate - Global Reach, Local Expertise, Solutions Beyond Borders" description="Avad Gate is a global leader in multisector industries, offering tailored solutions in raw materials, energy, manufacturing, marketing, and investments. Empowering growth beyond borders."  />
      
      <Suspense fallback={<div className="mt-[60px] min-h-[calc(100vh-60px)] bg-white" data-page-loading="true" aria-hidden="true" />}>
        {isDesktop ? <Banner currentLang={currentLang} /> : <BannerMob currentLang={currentLang} />}
      </Suspense>
      <div className="hidden">
        <a href="/services">Services</a>
        <a href="/about">About</a>
        <a href="/cars">AvadCars</a>
        <a href="/contactform">Contact</a>
        <a href="/naturalres">Natural Resources</a>
        <a href="/industrial">Industrial</a>
        <a href="/investments">Investments</a>
        <a href="/agro">AvadAgro</a>
        <a href="/realestate">RealEstate</a>
        <a href="/marketing">Marketing</a>
        <a href="/homelife">HomeLife</a>
        <a href="/construction">Construction</a>
      </div>
      
      <Suspense fallback={<div className="min-h-[640px]" data-page-loading="true" aria-hidden="true" />}>
        <Fade bottom><Mission/></Fade>
        <Fade bottom><Video/></Fade>
        <Fade bottom><OurValues currentLang={currentLang}/></Fade>
        <Fade bottom><CompanyHighlights currentLang={currentLang}/></Fade>
        <Fade bottom><GlobalPresence currentLang={currentLang}/></Fade>
        <Fade bottom><WhyChoose currentLang={currentLang}/></Fade>
        <Fade bottom><WhatOffer currentLang={currentLang}/></Fade>
        <Fade bottom><StayUpdated currentLang={currentLang}/></Fade>
        <Fade bottom><FeedBack currentLang={currentLang}/></Fade>
      </Suspense>
    </div>
  );
}

export default Home;
